var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJitosol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16345 24.8366 0 16 0C7.16345 0 0 7.16345 0 16C0 24.8366 7.16345 32 16 32Z",
    fill: "url(#paint0_linear_1_45)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 16C1.5 7.99188 7.99188 1.5 16 1.5C24.0081 1.5 30.5 7.99188 30.5 16C30.5 24.0081 24.0081 30.5 16 30.5C7.99188 30.5 1.5 24.0081 1.5 16ZM16 2.5C8.54416 2.5 2.5 8.54416 2.5 16C2.5 23.4558 8.54416 29.5 16 29.5C23.4558 29.5 29.5 23.4558 29.5 16C29.5 8.54416 23.4558 2.5 16 2.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.15479 12.2139H6.18078C6.17324 12.2168 6.16359 12.2168 6.15479 12.2139Z",
    fill: "#308D8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2962 19.1044C10.3981 19.0025 10.5383 18.943 10.6869 18.943H24.1676C24.414 18.943 24.5371 19.2403 24.363 19.4145L21.7 22.0775C21.5981 22.1794 21.4579 22.2389 21.3092 22.2389H7.82853C7.58219 22.2389 7.45902 21.9416 7.63316 21.7675L10.2962 19.1044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2962 9.16139C10.4024 9.05946 10.5425 9 10.6869 9H24.1676C24.414 9 24.5371 9.29731 24.363 9.47144L21.7 12.1345C21.5981 12.2364 21.4579 12.2958 21.3092 12.2958H7.82853C7.58219 12.2958 7.45902 11.9985 7.63316 11.8244L10.2962 9.16139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7 14.101C21.5981 13.9991 21.4579 13.9396 21.3092 13.9396H7.82853C7.58219 13.9396 7.45902 14.2369 7.63316 14.411L10.2962 17.0741C10.3981 17.176 10.5383 17.2354 10.6869 17.2354H24.1676C24.414 17.2354 24.5371 16.9381 24.363 16.764L21.7 14.101Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_45",
    x1: 24,
    y1: 24,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9B7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87D58F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJitosol);
export default __webpack_public_path__ + "static/media/jitosol.eaff32d020d04df79fe9d9cdbc4ec09c.svg";
export { ForwardRef as ReactComponent };